export { DMS_MODULE } from '../constants';

export const NAME = 'CustomerVerification';
export const CRUMB_LABEL_KEY = 'RpoDanVerification';
